<template>
  <v-card
    variant="flat"
    class="solicitacao-exames-card"
  >
    <!-- Header -->
    <div class="premium-header px-4 py-2">
      <v-row
        no-gutters
        align="center"
        dense
      >
        <v-col cols="auto">
          <div class="header-title">
            <v-icon
              color="grey-darken-3"
              class="mr-2"
            >
              medical_services
            </v-icon>
            <span class="text-subtitle-1 font-weight-medium text-grey-darken-3">Solicitação de Exames</span>
          </div>
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <div class="header-controls d-flex align-center">
            <v-switch
              :model-value="habilitarRqe"
              hide-details
              color="primary"
              class="mr-2"
              density="compact"
              label="RQE"
              @update:model-value="$emit('update:habilitarRqe', $event)"
            />
            <v-select
              v-if="habilitarRqe"
              :model-value="selectedRqe"
              :items="listaRqe"
              :loading="loadingRqe"
              item-title="rqe"
              item-value="id"
              label="Especialidade"
              density="compact"
              variant="outlined"
              hide-details
              style="width: 200px;"
              class="mr-4"
              @update:model-value="$emit('update:selectedRqe', $event)"
            />
            <v-switch
              v-model="dataHabilitada"
              hide-details
              color="primary"
              class="mr-2"
              density="compact"
              label="Data"
            />
            <v-menu
              v-if="dataHabilitada"
              v-model="menuData"
              :close-on-content-click="false"
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="dataFormatada"
                  density="compact"
                  variant="outlined"
                  color="primary"
                  readonly
                  v-bind="props"
                  hide-details
                  class="data-field"
                  style="width: 120px;"
                />
              </template>
              <v-date-picker 
                v-model="dataSelecionada" 
                locale="pt-BR"
                @update:model-value="menuData = false"
              />
            </v-menu>
          </div>
        </v-col>
      </v-row>
    </div>
    
    <!-- Conteúdo Principal -->
    <v-container
      fluid
      class="pa-2"
    >
      <!-- Busca e Modelos -->
      <v-row dense>
        <v-col
          cols="12"
          md="8"
        >
          <v-autocomplete
            v-model="exameSelecionado"
            v-model:search="termoBusca"
            :items="examesDisponiveis"
            :loading="carregandoExames"
            item-title="apelido"
            item-value="idExame"
            label="Digite o nome do exame"
            placeholder="Mínimo 2 caracteres para buscar..."
            prepend-inner-icon="search"
            variant="outlined"
            density="compact"
            color="primary"
            clearable
            return-object
            hide-details
            :disabled="!tipoExame"
            class="busca-autocomplete"
            @update:search="onBuscarExames"
          >
            <template #no-data>
              <v-list-item class="compact">
                <v-list-item-title class="text-caption text-center text-grey-darken-2 py-1">
                  <template v-if="!tipoExame">
                    Selecione o tipo de exame
                  </template>
                  <template v-else-if="carregandoExames">
                    Buscando...
                  </template>
                  <template v-else-if="termoBusca && termoBusca.length < 2">
                    Digite mais
                  </template>
                  <template v-else>
                    Nenhum exame encontrado
                  </template>
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-autocomplete
            v-model="modeloSelecionado"
            :items="modelosExames"
            :loading="carregandoModelos"
            item-title="nome"
            label="Buscar modelos"
            placeholder="Selecione um modelo..."
            prepend-inner-icon="folder_special"
            variant="outlined"
            density="compact"
            color="primary"
            clearable
            return-object
            hide-details
            :disabled="!tipoExame"
            class="busca-autocomplete"
          >
            <template #no-data>
              <v-list-item class="compact">
                <v-list-item-title class="text-caption text-center text-grey-darken-2 py-1">
                  <template v-if="!tipoExame">
                    Selecione o tipo de exame
                  </template>
                  <template v-else-if="carregandoModelos">
                    Carregando modelos...
                  </template>
                  <template v-else>
                    Nenhum modelo encontrado
                  </template>
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-dialog
        v-model="dialogAplicarModelo"
        width="420"
      >
        <v-card variant="outlined" style="background-color: rgb(var(--v-theme-surface)); color: rgb(var(--v-theme-on-surface));">
          <v-card-title>Aplicar modelo</v-card-title>
          <v-card-text>
            Escolha como deseja inserir o modelo
            <strong>{{ modeloPendente?.nome || '' }}</strong>.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn variant="text" @click="cancelarAplicacaoModelo">Cancelar</v-btn>
            <v-btn variant="outlined" @click="aplicarModeloSelecionado('substituir')">Substituir</v-btn>
            <v-btn color="primary" variant="flat" @click="aplicarModeloSelecionado('acrescentar')">Acrescentar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <!-- Exames Selecionados e Observações -->
      <v-card
        class="mt-2"
        flat
      >
        <v-card-title class="text-subtitle-2 font-weight-medium d-flex align-center text-grey-darken-3 py-2 px-3">
          <v-icon
            color="primary"
            class="mr-2"
            size="small"
          >
            checklist
          </v-icon>
          Exames Selecionados
          <v-chip
            color="primary"
            variant="flat"
            size="x-small"
            class="ml-2"
          >
            {{ examesSelecionados.length }}
          </v-chip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-2">
          <div
            v-if="examesSelecionados.length > 0"
            class="exames-chips-container"
          >
            <v-chip
              v-for="(exame, index) in examesSelecionados"
              :key="exame.idExame + '-' + index"
              closable
              variant="flat"
              :color="getChipColor(tipoExame)"
              size="small"
              class="ma-1"
              @click:close="removerExame(index)"
            >
              {{ exame.apelido }}
            </v-chip>
          </div>
          <div
            v-else
            class="empty-state-compact text-center py-5"
          >
            <v-icon
              size="32"
              color="grey-lighten-2"
              class="mb-2"
            >
              medical_services
            </v-icon>
            <div class="text-caption text-grey-lighten-1">
              Nenhum exame selecionado
            </div>
          </div>
        </v-card-text>
        <div v-if="examesSelecionados.length > 0">
          <v-divider />
          <v-textarea
            v-model="observacoes"
            label="Observações"
            variant="solo"
            flat
            color="primary"
            rows="2"
            hide-details
            auto-grow
            density="compact"
            class="ma-1"
          />
        </div>
      </v-card>
    </v-container>

    <!-- Dialog de Pacotes -->
    <v-dialog
      v-model="dialogPacotes"
      width="700"
      scrollable
    >
      <v-card>
        <v-toolbar
          color="primary"
          density="compact"
        >
          <v-toolbar-title class="text-white d-flex align-center">
            <v-icon
              icon="folder_special"
              start
              class="mr-2"
            />
            Meus Modelos de Exames
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            variant="text"
            class="text-white"
            @click="dialogPacotes = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <div
          v-if="carregandoModelos"
          class="text-center py-10"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
          <div class="mt-3 text-body-2 text-grey-darken-1">
            Carregando modelos...
          </div>
        </div>

        <div
          v-else-if="modelosExames.length === 0"
          class="text-center py-10"
        >
          <v-icon
            size="64"
            color="grey-lighten-1"
          >
            folder_off
          </v-icon>
          <div class="text-body-1 text-grey-darken-1 mt-2">
            Nenhum modelo encontrado
          </div>
        </div>

        <v-virtual-scroll
          v-else
          :items="modelosExames"
          height="420"
          item-height="72"
        >
          <template #default="{ item }">
            <v-list-item 
              :key="item.id || item._id"
              class="px-4 py-2 model-list-item"
            >
              <template #prepend>
                <v-avatar
                  color="primary-lighten-5"
                  size="40"
                >
                  <v-icon
                    color="primary"
                    size="20"
                  >
                    folder_special
                  </v-icon>
                </v-avatar>
              </template>

              <v-list-item-title class="text-body-2 font-weight-bold">
                {{ item.nome }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption">
                {{ (item.prescricoes || item.exames || []).length }} exame(s)
              </v-list-item-subtitle>

              <template #append>
                <v-menu location="bottom">
                  <template #activator="{ props }">
                    <v-btn
                      v-bind="props"
                      icon
                      variant="text"
                      size="small"
                    >
                      <v-icon size="18">
                        more_vert
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list density="compact">
                    <v-list-item @click="editarPacote(item)">
                      <template #prepend>
                        <v-icon size="18">
                          edit
                        </v-icon>
                      </template>
                      <v-list-item-title>Editar modelo</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="removerPacote(item)">
                      <template #prepend>
                        <v-icon size="18">
                          delete
                        </v-icon>
                      </template>
                      <v-list-item-title>Excluir modelo</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-list-item>
            <v-divider />
          </template>
        </v-virtual-scroll>
      </v-card>
    </v-dialog>

    <!-- Dialog de Cadastro/Edicao de Pacote -->
    <v-dialog
      v-model="dialogCadastroPacote"
      width="600"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          {{ pacoteEmEdicao ? 'Editar modelo' : 'Cadastrar modelo' }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="nomePacote"
            label="Nome do modelo"
            variant="outlined"
            density="compact"
            clearable
          />

          <v-divider class="my-3" />

          <v-autocomplete
            v-model="examePacoteSelecionado"
            v-model:search="termoBuscaPacote"
            :items="examesDisponiveis"
            :loading="carregandoExames"
            item-title="apelido"
            item-value="idExame"
            label="Adicionar exame ao modelo"
            placeholder="Digite o nome do exame..."
            prepend-inner-icon="search"
            variant="outlined"
            density="compact"
            color="primary"
            clearable
            return-object
            hide-details
            :disabled="!tipoExame"
            @update:search="onBuscarExames"
          >
            <template #no-data>
              <v-list-item class="compact">
                <v-list-item-title class="text-caption text-center text-grey-darken-2 py-1">
                  <template v-if="!tipoExame">
                    Selecione o tipo de exame
                  </template>
                  <template v-else-if="carregandoExames">
                    Buscando...
                  </template>
                  <template v-else-if="termoBuscaPacote && termoBuscaPacote.length < 2">
                    Digite mais
                  </template>
                  <template v-else>
                    Nenhum exame encontrado
                  </template>
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-autocomplete>

          <v-divider class="my-3" />

          <div class="text-caption text-grey-darken-1 mb-2">
            Exames do modelo
          </div>
          <div
            v-if="examesPacote.length > 0"
            class="exames-chips-container"
          >
            <v-chip
              v-for="(exame, index) in examesPacote"
              :key="exame.idExame + '-' + index"
              closable
              size="small"
              class="ma-1"
              @click:close="removerExamePacote(index)"
            >
              {{ exame.apelido || exame.nome }}
            </v-chip>
          </div>
          <div
            v-else
            class="text-caption text-grey-darken-1"
          >
            Nenhum exame no modelo
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            variant="text"
            color="grey-darken-1"
            @click="fecharCadastroPacote"
          >
            Cancelar
          </v-btn>
          <v-btn
            :loading="salvandoPacote"
            :disabled="!nomePacote || examesPacote.length === 0"
            color="primary"
            variant="flat"
            @click="salvarPacote"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
// O script permanece exatamente o mesmo
import { ref, computed, watch, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'
import medicoService from '@/services/medico.service'

// Função debounce para evitar múltiplas chamadas API
function debounce(fn, delay) {
  let timeoutId
  return function(...args) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn.apply(this, args), delay)
  }
}

// Funções para formatação de data no padrão pt-BR
function formatarDataParaBrasileiro(data) {
  if (!data) return ''
  
  // Se for string, verifica o formato
  if (typeof data === 'string') {
    if (data.match(/^\d{4}-\d{2}-\d{2}$/)) {
      // Formato YYYY-MM-DD
      const [ano, mes, dia] = data.split('-')
      return `${dia}/${mes}/${ano}`
    }
    if (data.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
      // Já está no formato DD/MM/YYYY
      return data
    }
  }
  
  // Se for objeto Date
  if (data instanceof Date && !isNaN(data.getTime())) {
    const dia = String(data.getDate()).padStart(2, '0')
    const mes = String(data.getMonth() + 1).padStart(2, '0')
    const ano = data.getFullYear()
    return `${dia}/${mes}/${ano}`
  }
  
  return String(data || '')
}

function dataParaISO(data) {
  if (!data) return ''
  
  // Se for objeto Date
  if (data instanceof Date && !isNaN(data.getTime())) {
    return data.toISOString().split('T')[0]
  }
  
  // Se for string no formato DD/MM/YYYY
  if (typeof data === 'string' && data.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    const [dia, mes, ano] = data.split('/')
    return `${ano}-${mes}-${dia}`
  }
  
  // Se já estiver no formato YYYY-MM-DD
  if (typeof data === 'string' && data.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return data
  }
  
  return ''
}

export default {
  name: 'SolicitacaoExames',
  props: {
    idConsulta: {
      type: Number,
      required: true
    },
    examesEdit: {
      type: Array,
      default: () => []
    },
    isEdicao: {
      type: Boolean,
      default: false
    },
    dadosEdicao: {
      type: Object,
      default: null
    },
    paciente: {
      type: Object,
      required: true
    },
    habilitarRqe: Boolean,
    selectedRqe: [Number, String],
    listaRqe: Array,
    loadingRqe: Boolean
  },
  emits: ['cancelar', 'salvar-solicitacao', 'update-actions-state', 'update-observacoes', 'update:habilitarRqe', 'update:selectedRqe'],
  setup(props, { emit }) {
    const store = useStore()
    const user = computed(() => store.getters.usuario)
    
    // Estados reativos
    const tipoExame = ref('CLINICA')
    const dataHabilitada = ref(true)
    const dataSelecionada = ref(new Date())
    const menuData = ref(false)
    const examesSelecionados = ref([])
    const exameSelecionado = ref(null)
    const termoBusca = ref('')
    const examesDisponiveis = ref([])
    const carregandoExames = ref(false)
    const observacoes = ref('')
    const salvando = ref(false)
    const debouncedBuscarExames = ref(null)
    const modelosExames = ref([])
    const modeloSelecionado = ref(null)
    const modeloPendente = ref(null)
    const dialogAplicarModelo = ref(false)
    const carregandoModelos = ref(false)
    const dialogPacotes = ref(false)
    const dialogCadastroPacote = ref(false)
    const nomePacote = ref('')
    const examesPacote = ref([])
    const pacoteEmEdicao = ref(null)
    const salvandoPacote = ref(false)
    const examePacoteSelecionado = ref(null)
    const termoBuscaPacote = ref('')
    
    // Computed - Formata a data para exibição
    const dataFormatada = computed(() => {
      return formatarDataParaBrasileiro(dataSelecionada.value)
    })

    // Métodos
    const getChipColor = (tipo) => {
      switch(tipo) {
        case 'LABORATORIO': return 'blue-lighten-5'
        case 'CLINICA': return 'green-lighten-5'
        case 'CIRURGIA': return 'red-lighten-5'
        default: return 'grey-lighten-4'
      }
    }

    const getButtonColor = (tipo) => {
      switch(tipo) {
        case 'LABORATORIO': return 'blue-darken-2'
        case 'CLINICA': return 'green-darken-2'
        case 'CIRURGIA': return 'red-darken-2'
        default: return 'primary'
      }
    }

    const buscarExames = async (termo) => {
      if (!tipoExame.value || !termo || termo.length < 2) {
        examesDisponiveis.value = []
        return
      }
      
      carregandoExames.value = true
      try {
          const resposta = await medicoService.medico.listarExamesPorNome(termo, tipoExame.value)
          examesDisponiveis.value = resposta.data || []
      } catch (erro) {
        console.error('Erro ao buscar exames:', erro)
        examesDisponiveis.value = []
      } finally {
        carregandoExames.value = false
      }
    }
    
    const carregarModelosExames = async () => {
      const idUsuario = user.value?.id || user.value?._id
      const idUnidade = user.value?.idUnidade || user.value?.voucher?.idUnidadeNegocio || props.paciente?.idUnidade
      if (!idUsuario) return
      carregandoModelos.value = true
      try {
        const isLaboratorio = tipoExame.value === 'LABORATORIO'
        const resposta = await medicoService.medico.buscarPacoteExames(
          idUsuario,
          isLaboratorio,
          idUnidade
        )
        if (resposta.status === 200) {
          modelosExames.value = resposta.data || []
        } else {
          modelosExames.value = []
        }
      } catch (erro) {
        console.error('Erro ao carregar modelos:', erro)
        modelosExames.value = []
      } finally {
        carregandoModelos.value = false
      }
    }

    const onBuscarExames = (termo) => {
      if (termo && typeof termo === 'string' && termo.length >= 2) {
        debouncedBuscarExames.value(termo)
      } else {
        examesDisponiveis.value = []
      }
    }

    const adicionarExame = (exame) => {
      if (!exame || !exame.idExame) return
      
      if (!examesSelecionados.value.some(e => e.idExame === exame.idExame)) {
        examesSelecionados.value.push(exame)
      }
      exameSelecionado.value = null
      termoBusca.value = ''
    }

    const adicionarExamePacote = (exame) => {
      if (!exame || !exame.idExame) return
      if (!examesPacote.value.some(e => e.idExame === exame.idExame)) {
        examesPacote.value.push(exame)
      }
      examePacoteSelecionado.value = null
      termoBuscaPacote.value = ''
    }

    const adicionarModelo = (modelo, modo = 'acrescentar') => {
      const examesModelo = modelo.prescricoes || modelo.exames || []
      if (modo === 'substituir') {
        examesSelecionados.value = []
      }
      examesModelo.forEach(adicionarExame)
    }

    const aplicarModeloSelecionado = (modo) => {
      if (!modeloPendente.value) return
      adicionarModelo(modeloPendente.value, modo)
      cancelarAplicacaoModelo()
    }

    const cancelarAplicacaoModelo = () => {
      dialogAplicarModelo.value = false
      modeloPendente.value = null
      modeloSelecionado.value = null
    }

    const removerExame = (index) => {
      examesSelecionados.value.splice(index, 1)
    }

    const limparSelecao = () => { // This method is called by parent, so it should be exposed
      examesSelecionados.value = []
      examesDisponiveis.value = []
      termoBusca.value = ''
      observacoes.value = ''
      tipoExame.value = 'CLINICA' // Reset to default
    }

    const cancelar = () => { // This method is called by parent, so it should be exposed
      emit('cancelar')
    }

    const abrirDialogPacotes = () => {
      dialogPacotes.value = true
      carregarModelosExames()
    }

    const abrirCadastroPacote = () => {
      pacoteEmEdicao.value = null
      nomePacote.value = ''
      examesPacote.value = examesSelecionados.value.map(exame => ({ ...exame }))
      dialogCadastroPacote.value = true
    }

    const editarPacote = (pacote) => {
      pacoteEmEdicao.value = pacote
      nomePacote.value = pacote.nome || ''
      examesPacote.value = (pacote.prescricoes || pacote.exames || []).map(exame => ({ ...exame }))
      examePacoteSelecionado.value = null
      termoBuscaPacote.value = ''
      dialogCadastroPacote.value = true
      dialogPacotes.value = false
    }

    const removerExamePacote = (index) => {
      examesPacote.value.splice(index, 1)
    }

    const fecharCadastroPacote = () => {
      dialogCadastroPacote.value = false
      nomePacote.value = ''
      examesPacote.value = []
      pacoteEmEdicao.value = null
      examePacoteSelecionado.value = null
      termoBuscaPacote.value = ''
    }

    const salvarPacote = async () => {
      if (!user.value?.id) return
      salvandoPacote.value = true
      try {
        const pacoteId = pacoteEmEdicao.value?.id || pacoteEmEdicao.value?._id || null
        const idUnidade = user.value.idUnidade || user.value.voucher?.idUnidadeNegocio || ''
        const idMedico = user.value.id || user.value._id || ''
        await medicoService.medico.cadastrarPacoteExame({
          idPacote: pacoteId || '',
          nome: nomePacote.value,
          idUnidade,
          idMedico,
          exames: examesPacote.value.map(exame => ({ ...exame })),
          sadt: tipoExame.value === 'LABORATORIO',
          ativo: true
        })
        fecharCadastroPacote()
        carregarModelosExames()
      } catch (erro) {
        console.error('Erro ao salvar pacote:', erro)
      } finally {
        salvandoPacote.value = false
      }
    }

    const removerPacote = async (pacote) => {
      if (!user.value?.id) return
      salvandoPacote.value = true
      try {
        const pacoteId = pacote?.id || pacote?._id || ''
        const idUnidade = user.value.idUnidade || user.value.voucher?.idUnidadeNegocio || ''
        const idMedico = user.value.id || user.value._id || ''
        const examesPacoteAtual = pacote?.exames || pacote?.prescricoes || []
        await medicoService.medico.cadastrarPacoteExame({
          idPacote: pacoteId,
          nome: pacote?.nome || '',
          idUnidade,
          idMedico,
          exames: examesPacoteAtual.map(exame => ({ ...exame })),
          sadt: tipoExame.value === 'LABORATORIO',
          ativo: false
        })
        carregarModelosExames()
      } catch (erro) {
        console.error('Erro ao remover pacote:', erro)
      } finally {
        salvandoPacote.value = false
      }
    }

    const salvarSolicitacao = async () => {
      salvando.value = true
      if (examesSelecionados.value.length === 0) {
        salvando.value = false;
        return
      }
      try {
        console.log('[solicitacaoExames] iniciar salvarSolicitacao', {
          examesSelecionados: examesSelecionados.value,
          observacoes: observacoes.value,
          dataHabilitada: dataHabilitada.value,
          dataSelecionada: dataSelecionada.value,
          tipoExame: tipoExame.value,
          isEdicao: props.isEdicao,
          paciente: props.paciente
        })
        const payload = {
          items: examesSelecionados.value,
          observacoes: observacoes.value,
          isObs: observacoes.value.length > 0,
          data: dataHabilitada.value ? dataFormatada.value : null,
          dataISO: dataHabilitada.value ? dataParaISO(dataSelecionada.value) : null,
          dataHabilitada: dataHabilitada.value,
          tipo: tipoExame.value
        };

        if (props.isEdicao) {
          const idSolicitacao = props.dadosEdicao.items?.[0]?.idSolicitacao;
          if (!idSolicitacao) {
            console.error('Erro: idSolicitacao não encontrado para atualização.');
            return;
          }
          console.log('[solicitacaoExames] atualizarSolicitacaoExame payload', {
            idSolicitacao,
            exames: examesSelecionados.value
          })
          await medicoService.medico.atualizarSolicitacaoExame(
            idSolicitacao,
            examesSelecionados.value,
            observacoes.value
          );
          payload.idSolicitacao = idSolicitacao;
        } else {
          const idAtendimento = props.paciente?.idAtendimento || props.paciente?.idConsulta || '';
          const idMedico = props.paciente?.idMedico || user.value?.id || user.value?._id || '';
          if (!idAtendimento || !idMedico) {
            console.error('Erro ao salvar solicitação: idAtendimento ou idMedico ausente.', {
              idAtendimento,
              idMedico
            })
          }
          console.log('[solicitacaoExames] cadastrarSolicitacaoExame payload', {
            idAtendimento,
            idMedico,
            exames: examesSelecionados.value,
            observacao: observacoes.value
          })
          await medicoService.medico.cadastrarSolicitacaoExame(
            idAtendimento,
            idMedico,
            examesSelecionados.value,
            observacoes.value
          );
        }

        console.log('[solicitacaoExames] salvarSolicitacao emit payload', payload)
        emit('salvar-solicitacao', payload);
      } catch (erro) {
        console.error('Erro ao salvar solicitação:', erro)
      } finally {
        salvando.value = false
      }
    }

    const carregarDadosEdicao = () => {
      if (props.dadosEdicao && props.isEdicao) {
        // 1. Define o tipo de exame (LABORATORIO, CLINICA, etc.)
        tipoExame.value = props.dadosEdicao.tipo || 'CLINICA'
        
        // 2. Extrai a lista de exames. A estrutura dos dados de edição
        //    sugere que 'items' é um array de solicitações, e cada
        //    solicitação tem um array 'exames'. Precisamos nivelar.
        const examesAninhados = props.dadosEdicao.items || []
        
        // Nivelar (flat-map) a lista de exames de todas as solicitações em 'items'
        // Embora no exemplo haja apenas 1 item, a abordagem é robusta.
        const examesNivelados = examesAninhados.flatMap(item => item.exames || [])
        
        // Preenche o estado reativo com a lista nivelada de exames
        examesSelecionados.value = examesNivelados
        
        // 3. Define as observações
        observacoes.value = props.dadosEdicao.observacoes || ''
        
        // 4. Define a data, se houver
        const dataHabilitadaExplicit = Object.prototype.hasOwnProperty.call(props.dadosEdicao, 'dataHabilitada')
        const dataHabilitadaTrue = dataHabilitadaExplicit && props.dadosEdicao.dataHabilitada
        if (dataHabilitadaExplicit && !props.dadosEdicao.dataHabilitada) {
          dataHabilitada.value = false;
        } else if (props.dadosEdicao.dataISO) {
          // Tenta criar um objeto Date. Adiciona 'T00:00:00' para evitar
          // problemas de fuso horário que podem mudar o dia ao inicializar.
          const data = new Date(props.dadosEdicao.dataISO + 'T00:00:00')
          if (!isNaN(data.getTime())) {
            dataSelecionada.value = data
            dataHabilitada.value = true
          } else {
            console.error('Data ISO inválida para edição:', props.dadosEdicao.dataISO);
            if (dataHabilitadaTrue) {
              dataSelecionada.value = new Date();
              dataHabilitada.value = true;
            } else {
              dataHabilitada.value = false;
            }
          }
        } else if (props.dadosEdicao.data) {
             // Caso a data não seja ISO (por exemplo, DD/MM/YYYY), tenta analisar
             const [dia, mes, ano] = props.dadosEdicao.data.split('/');
             const data = new Date(Number(ano), Number(mes) - 1, Number(dia));
             if (!isNaN(data.getTime())) {
                dataSelecionada.value = data;
                dataHabilitada.value = true;
             } else {
                if (dataHabilitadaTrue) {
                  dataSelecionada.value = new Date();
                  dataHabilitada.value = true;
                } else {
                  dataHabilitada.value = false;
                }
             }
        } else if (dataHabilitadaTrue) {
             dataSelecionada.value = new Date();
             dataHabilitada.value = true;
        } else {
             dataHabilitada.value = false;
        }
      }
    }

    // Watchers
    watch(exameSelecionado, adicionarExame)
    watch(examePacoteSelecionado, adicionarExamePacote)
    watch(modeloSelecionado, (novoModelo) => {
      if (novoModelo) {
        modeloPendente.value = novoModelo
        if (examesSelecionados.value.length === 0) {
          aplicarModeloSelecionado('substituir')
        } else {
          dialogAplicarModelo.value = true
          modeloSelecionado.value = null
        }
      }
    })
    watch(tipoExame, () => {
      examesDisponiveis.value = []
      termoBusca.value = ''
      modelosExames.value = []
      modeloSelecionado.value = null
      carregarModelosExames()
    })
    watch(examesSelecionados, (newValue) => {
      emit('update-actions-state', {
        canSave: newValue.length > 0,
        canClear: newValue.length > 0
      })
    }, { deep: true, immediate: true })
    watch(observacoes, (newValue) => {
      emit('update-observacoes', {
        observacoes: newValue,
        isObs: newValue.length > 0
      })
    })

    // Inicialização
    onMounted(() => {
      debouncedBuscarExames.value = debounce(buscarExames, 300)
      carregarModelosExames()
      if (!(dataSelecionada.value instanceof Date) || isNaN(dataSelecionada.value.getTime())) {
        dataSelecionada.value = new Date()
      }
      nextTick(carregarDadosEdicao)
    })

    return {
      user,
      tipoExame,
      dataHabilitada,
      dataSelecionada,
      menuData,
      examesSelecionados,
      exameSelecionado,
      termoBusca,
      examesDisponiveis,
      carregandoExames,
      observacoes,
      salvando,
      modelosExames,
      modeloSelecionado,
      modeloPendente,
      dialogAplicarModelo,
      carregandoModelos,
      dialogPacotes,
      dialogCadastroPacote,
      nomePacote,
      examesPacote,
      pacoteEmEdicao,
      salvandoPacote,
      examePacoteSelecionado,
      termoBuscaPacote,
      dataFormatada,
      getChipColor,
      getButtonColor,
      onBuscarExames,
      adicionarModelo,
      aplicarModeloSelecionado,
      cancelarAplicacaoModelo,
      removerExame,
      abrirDialogPacotes,
      abrirCadastroPacote,
      editarPacote,
      removerExamePacote,
      fecharCadastroPacote,
      salvarPacote,
      removerPacote,
      limparSelecao,
      cancelar,
      salvarSolicitacao
    }
  }
}
</script>

<style scoped>
.solicitacao-exames-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
}

.premium-header {
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.12);
}

.data-field {
  max-width: 130px;
}

.busca-autocomplete :deep(.v-field__input) {
  padding-top: 2px;
  padding-bottom: 2px;
}

.exames-chips-container {
  min-height: 80px;
  max-height: 250px;
  overflow-y: auto;
  border: 1px dashed rgba(var(--v-theme-on-surface), 0.2);
  border-radius: 4px;
  padding: 8px;
  background-color: rgba(var(--v-theme-on-surface), 0.02);
}

.empty-state-compact {
  border-style: dashed;
}

.actions-footer {
  border-top: 1px solid rgba(var(--v-theme-on-surface), 0.12);
}

.model-list-item:hover {
  background-color: rgba(var(--v-theme-on-surface), 0.04);
}
</style>
